// ค่าชดเชยตาม พ.ร.บ.คุ้มครองแรงงาน (มาตรา 118)
// อัตราตามอายุงาน — ลูกจ้างต้องทำงานครบ 120 วันขึ้นไปจึงมีสิทธิ
//   ≥120 วัน–<1 ปี : 30 วัน
//   1–<3 ปี        : 90 วัน
//   3–<6 ปี        : 180 วัน
//   6–<10 ปี       : 240 วัน
//   10–<20 ปี      : 300 วัน
//   ≥20 ปี         : 400 วัน
// หมายเหตุ: นี่เป็น "ตัวช่วยคำนวณเบื้องต้น" — กรณีจริงควรให้ทนายแรงงานตรวจ
// (ไม่รวมกรณีเลิกจ้างได้โดยไม่ต้องจ่ายค่าชดเชยตามมาตรา 119)

export const SEVERANCE_TIERS = [
  { key: 't30', days: 30, label: 'ทำงาน ≥120 วัน แต่ไม่ถึง 1 ปี' },
  { key: 't90', days: 90, label: 'ทำงาน 1 ปี ขึ้นไป แต่ไม่ถึง 3 ปี' },
  { key: 't180', days: 180, label: 'ทำงาน 3 ปี ขึ้นไป แต่ไม่ถึง 6 ปี' },
  { key: 't240', days: 240, label: 'ทำงาน 6 ปี ขึ้นไป แต่ไม่ถึง 10 ปี' },
  { key: 't300', days: 300, label: 'ทำงาน 10 ปี ขึ้นไป แต่ไม่ถึง 20 ปี' },
  { key: 't400', days: 400, label: 'ทำงาน 20 ปี ขึ้นไป' },
];

function tierFor(tenureDays) {
  const y = tenureDays / 365;
  if (tenureDays < 120) return null;          // ยังไม่มีสิทธิค่าชดเชย
  if (y < 1) return SEVERANCE_TIERS[0];
  if (y < 3) return SEVERANCE_TIERS[1];
  if (y < 6) return SEVERANCE_TIERS[2];
  if (y < 10) return SEVERANCE_TIERS[3];
  if (y < 20) return SEVERANCE_TIERS[4];
  return SEVERANCE_TIERS[5];
}

// monthlySalary = เงินเดือนฐานต่อเดือน · includeNotice = บวกค่าบอกกล่าวล่วงหน้า 1 งวด
export function severanceCalc(tenureDays, monthlySalary, includeNotice = true) {
  const salary = Number(monthlySalary) || 0;
  const daily = salary / 30;
  const tier = tierFor(tenureDays);
  const severanceDays = tier ? tier.days : 0;
  const severanceAmount = Math.round(severanceDays * daily);
  // ค่าบอกกล่าวล่วงหน้า = ค่าจ้าง 1 งวด (กรณีเลิกจ้างไม่บอกล่วงหน้า)
  const noticeAmount = includeNotice ? Math.round(salary) : 0;
  return {
    eligible: !!tier,
    tier,
    severanceDays,
    severanceAmount,
    noticeAmount,
    total: severanceAmount + noticeAmount,
    tenureLabel: `${Math.floor(tenureDays / 365)} ปี ${Math.floor((tenureDays % 365) / 30)} เดือน`,
  };
}

export const baht = (n) => '฿' + Number(n || 0).toLocaleString('th-TH');
